import './index.scss'

import I18n from '@app/javascript/i18n/index.js.erb'
import ApplicationController from '@app/javascript/controllers/application_controller'
import { updateInboxEntries } from '@app/javascript/classes/inbox'

export class Controller extends ApplicationController {
  static values = {
    inboxId: String,
    entityId: String,
    isRead: Boolean,
    isIrrelevant: Boolean,
    isWatchlisted: Boolean
  }

  static targets = ['readToggle', 'irrelevantToggle', 'irrelevantBadge']

  doConnect() {}

  onTagsUpdated(event) {
    const labelsUpdated = event.detail.model?.toLowerCase() === 'labels'
    const issuesUpdated = event.detail.model?.toLowerCase() === 'issues'
    const details = event.detail.details

    if (labelsUpdated) this.setRead(null, details)
    if (issuesUpdated) this.setReadAndWatchlisted(null, details)
  }

  markAsReadAndNavigate(event) {
    if (this.isReadValue) return

    // We intentionally skip event.preventDefault() to properly redirect outside of the iframe

    updateInboxEntries(this.inboxIdValue,
      {
        entity_ids: this.entityIds(),
        is_read: true
      },
      () => {
        this.isReadValue = true
      }
    )
  }

  setReadAndWatchlisted(_ev, details) {
    if (this.isReadValue && this.isWatchlistedValue) return

    updateInboxEntries(this.inboxIdValue,
      {
        entity_ids: this.entityIds(),
        is_read: true,
        is_watchlisted: true,
        details: details
      },
      () => {
        this.isReadValue = true
        this.isWatchlistedValue = true
      }
    )
  }

  setRead(_ev, details) {
    if (this.isReadValue) return

    this.toggleRead(null, true, details)
  }

  setIrrelevant(_ev, details) {
    if (this.isIrrelevantValue) return

    this.toggleIrrelevant(null, true, details)
  }

  setRelevant(_ev, details) {
    if (this.isIrrelevantValue === false) return

    this.toggleIrrelevant(null, false, details)
  }

  toggleRead(_ev, forcedValue = undefined, details = undefined) {
    const newIsReadValue = forcedValue !== undefined ? forcedValue : !this.isReadValue

    updateInboxEntries(this.inboxIdValue,
      {
        entity_ids: this.entityIds(),
        is_read: newIsReadValue,
        details: details
      },
      () => {
        this.isReadValue = newIsReadValue
      }
    )
  }

  toggleIrrelevant(_ev, forcedValue = undefined, details = undefined) {
    const newIsIrrelevantValue = forcedValue !== undefined ? forcedValue : !this.isIrrelevantValue
    const isMarkingAsIrrelevant = newIsIrrelevantValue === true

    const params = {
      entity_ids: this.entityIds(),
      is_irrelevant: newIsIrrelevantValue,
      details: details
    }

    if (isMarkingAsIrrelevant) {
      params.is_read = true
    }

    updateInboxEntries(this.inboxIdValue, params, () => this.toggleIrrelevantSuccess(newIsIrrelevantValue))
  }

  toggleIrrelevantSuccess(markedIrrelevant) {
    this.isIrrelevantValue = markedIrrelevant

    if (markedIrrelevant) {
      this.isReadValue = true
    }

    if (this.isIrrelevantValue) {
      this.dispatch(`${this.entityIdValue}:markedIrrelevantDone`)
    } else {
      this.dispatch(`${this.entityIdValue}:markedRelevantDone`)
    }
  }

  isReadValueChanged() {
    if (this.isReadValue) {
      this.readToggleTarget.textContent = I18n.t('search_v2.item.mark_as_unread')
      this.element.classList.remove('c-search-v2--inbox-result-item-unread')

      this.dispatch(`${this.entityIdValue}:markedReadDone`)
    } else {
      this.readToggleTarget.textContent = I18n.t('search_v2.item.mark_as_read')
      this.element.classList.add('c-search-v2--inbox-result-item-unread')

      this.dispatch(`${this.entityIdValue}:markedUnreadDone`)
    }

    this.dispatch('entityToggledRead')
  }

  isIrrelevantValueChanged() {
    if (this.isIrrelevantValue) {
      this.irrelevantToggleTarget.textContent = I18n.t('search_v2.item.undo_mark_irrelevant')
    } else {
      this.irrelevantToggleTarget.textContent = I18n.t('search_v2.item.mark_as_irrelevant')
    }
  }

  entityIds() {
    return [this.entityIdValue]
  }

  dispatch(eventName) {
    if (!this.connected) return

    this.dispatchCustomEvent(`inbox:${eventName}`, { scoped: false, detail: { inboxId: this.inboxIdValue } })
  }
}
